<template>
    <div class="small-card" @click="$emit('click')">
        <div class="small-card-content">
            <img class="small-card-img" :src="`/api/v1/file/${url}`" alt="">
        </div>

        <div class="small-card-bottom line-clamp-2">{{name}}</div>
    </div>
</template>

<script>
    export default {
        name: "SmallCard",
        props: {
            url: {
                type: String,
                default: ''
            },
            name:{
                type: String,
                default: ''
            }
        },
    }
</script>

<style scoped lang="less">
    .small-card{
        width: 100%;
        height: 240px;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        border-radius: 6px;
        overflow: hidden;

        .small-card-content{
            width: 100%;
            height: 175px;
            overflow: hidden;
        }
        .small-card-img{
            width: 100%;
            height: 175px;
            object-fit: cover;
            transition: 0.3s;
            &:hover{
                transform: scale(1.1);
            }
        }
        .small-card-bottom{
            padding: 10px;
            width: 100%;
            font-size: 14px;
            text-align: left;
            box-sizing: border-box;
            &:hover{
                color: #e44646 !important;
            }
        }
    }
</style>
